/**
 * @desc http请求封装
 * @author Alinc
 * @time 2019-10-9 10:53:06
 */
import axios from 'axios'
import { INTERRUPT } from '@constants'
import router from '@router/index'
import store from '@store'
import Vue from 'vue'

const self = new Vue()

let isto = true

// 创建axios实例
const service = axios.create()

// 设置请求的基础路径
service.defaults.baseURL = process.env.VUE_APP_API_URL
console.log(process.env)
// 定义请求的中断请求函数
const CancelToken = axios.CancelToken
function padLeft(str, numChars = 4, char = ' ') {
  return (Array.from({ length: numChars }).fill(char).join('') + str).slice(-1 * numChars)
}
// request拦截器
service.interceptors.request.use(config => {
  // 获取vuex的token
  const { token = '' } = store.getters
  config.data = config.data || {}
  // 设置取消请求的方法
  config.cancelToken = new CancelToken(c => store.state.base.httpInstanceList.push(c))
  // 请求方法为post
  // if (config.method === 'post') {
  //   // 根据post参数自动添加公用参数countryId
  //   typeof config.data === 'object' ? config.data.countryId = '1' : config.data += '&countryId=1'
  //   if (typeof config.data === 'object') {
  //     if (config.data['newData']) {
  //       config.data['newData'].countryId = '1'
  //       config.data['oldData'].countryId = '1'
  //     }
  //   }
  // }
  if (!config.headers.timezone) {
    // 浏览器客户端所在时区
    // 判断是否夏令时 如果夏令时则时间往前拨一个小时
    const timezoneVal = 0 - new Date().getTimezoneOffset() / 60
    const numberFlag = timezoneVal && typeof timezoneVal === 'number' && timezoneVal % 1 === 0
    config.headers.timezone = 'GMT' + (parseInt(timezoneVal) > 0 ? '+' : '-') + (numberFlag ? Math.abs(timezoneVal) : `${padLeft(Math.abs(parseInt(timezoneVal)), 2, '0')}${Math.abs(timezoneVal) % 1 * 60}`)
  }
  // 获取当前路由名称
  const routeName = router.history.current.name
  // 设置请求头authToken
  config.headers.authToken = token
  // 设置请求头routeName
  config.headers.routeName = routeName
  // 通用模块的国际化请求头
  const lang = localStorage.getItem('lang') || store.getters.lang
  config.headers.language = lang
  //  设置了缓存，如果请求参数没变又要实时返回，请在请求后面加时间戳
  config.headers['Cache-Control'] = 'max-age=2, must-revalidate'
  // console.log(config)
  return config
}, error => {
  return Promise.reject(error)
})

let isTip = true

let timer = null
// respone拦截器
service.interceptors.response.use((response) => {
  const { responseType, url } = response.config
  if (url.indexOf('/vip/waybillOrder/export') > -1 || url.indexOf('/vip/order/downloadTemplate') > -1) {
    console.log('导出：response', response)
  }
  // 请求状态码为200
  if (response.status === 200) {
    if (url.indexOf('/logib') > -1) {
      isTip = true
      return
    }
    // 149010008
    if (response.data.code === 149010008) {
      if (isTip) {
        clearTimeout(timer)
        timer = setTimeout(() => {
          isTip = false
          store.dispatch('LOGIN_OUT').then(() => {
            router.push({ name: 'login' })
            // self.$message.error('没有访问权限，请重新登录')
          })
        }, 500)
      }
      setTimeout(() => {
        isTip = true
      }, 400)
    }
    if (responseType === 'blob' && response.data.type === 'application/json') {
      // 将blob文件流转换成json
      const reader = new FileReader()
      let blobData
      reader.onload = function (event) {
        const message = JSON.parse(reader.result).msg
        blobData = JSON.parse(reader.result)
        console.log(message)
        console.log(blobData)
        self.$message.error(message) // 将错误信息显示出来
      }
      reader.readAsText(response.data)
      return 'error'
    }
    return response.data
  }
}, (error) => {
  // 判断请求异常信息中是否含有超时timeout字符串
  if (error.message.includes('timeout')) {
    self.$message.error(self.$lang('请求超时！'))
    return Promise.reject(error)
  }
  if (error.response) {
    if (error.response.status === 401 && isto) { // token过期
      isto = false
      store.dispatch('LOGIN_OUT', 'requestError').then(() => {
        router.push({ name: 'login' })
        self.$message.error(this.$lang('权限已失效，请重新登录'))
      })
    } else if (error.response.status === 403 && isto) {
      isto = false
      store.dispatch('LOGIN_OUT', 'requestError').then(() => {
        router.push({ name: 'login' })
        self.$message.error(this.$lang('您的账号在另一地点登录，请重新登录'))
      })
    }
    setTimeout(() => (isto = true), 1000)
  }
  // 判断是否主动中断请求的类型
  if (error.message && error.message.includes(INTERRUPT)) {
    console.log('已中断请求')
    // 移除当前页的路由缓存(error.message包含页面相关的路由name)
    const name = error.message.replace(INTERRUPT + '|', '')
    // 移除路由缓存
    store.dispatch('DEL_CACHED_VIEW', { name })
  }
  // 避免项目中对返回数据结构报异常
  return Promise.reject(error)
})

export const get = (url, params) => service.get(url, { params })
export const post = service.post
export const put = service.put
export const del = service.delete

export default service
